/* Copyright (c) 2016-2023 Planticle Pty Ltd */
"use strict";

import _ from "underscore";

var program = {
	code: "birdata",
	name: "General Birdata survey",
	description: "Atlas & Birdata is BirdLife Australia's longest running monitoring program and one of our greatest resources, allowing us to track changes in birds across the country.",
	fields: function() { return {}; },
	programData: function() { return {}; },
	visibleSharedSiteLayers: () => ["birdata"]
};

export default program;
